"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggregateRootBase = exports.ValueObjectBase = void 0;
const ddd_1 = require("@leavy/ddd");
const transformer_1 = require("@leavy/validator/lib/base/transformer");
class ValueObjectBase extends ddd_1.ValueObjectBase {
    constructor() {
        super();
    }
    initialize(data) {
        if (data) {
            const anyThis = this;
            for (const key in data) {
                if (anyThis[key] === undefined || data[key] !== undefined) {
                    anyThis[key] = data[key];
                }
            }
        }
    }
    toJSON() {
        return (0, transformer_1.classToPlain)(this);
    }
}
exports.ValueObjectBase = ValueObjectBase;
class AggregateRootBase extends ddd_1.AggregateRootBase {
    constructor(id) {
        super(id);
    }
    initialize(data) {
        if (data) {
            const anyThis = this;
            for (const key in data) {
                if (anyThis[key] === undefined || data[key] !== undefined) {
                    anyThis[key] = data[key];
                }
            }
        }
    }
    toJSON() {
        return (0, transformer_1.classToPlain)(this);
    }
}
exports.AggregateRootBase = AggregateRootBase;
//# sourceMappingURL=ddd.js.map